'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setItem = setItem;
function setItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (err) {
    // ignore
  }
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.520/js/init/internal/localStorage.js
// module id = 133
// module chunks = 177 178